(() => {
  const patchGroupRows = (scope = document) => {
    scope.querySelectorAll('[data-soundhous-compare-root] .shcmp-group-row').forEach((row) => {
      if (row.dataset.shcmpR5Patched === 'true') return;

      const heading = row.querySelector(':scope > th[colspan]');
      if (!heading) return;

      const productColumnCount = Number.parseInt(heading.getAttribute('colspan') || '1', 10);
      heading.removeAttribute('colspan');
      heading.classList.add('shcmp-group-title');

      const continuation = document.createElement('td');
      continuation.className = 'shcmp-group-fill';
      continuation.colSpan = Math.max(productColumnCount, 1);
      continuation.setAttribute('aria-hidden', 'true');
      row.appendChild(continuation);

      row.dataset.shcmpR5Patched = 'true';
    });
  };

  const init = () => {
    patchGroupRows();

    document.querySelectorAll('[data-soundhous-compare-root]').forEach((root) => {
      if (root.dataset.shcmpR5Observer === 'true') return;
      root.dataset.shcmpR5Observer = 'true';

      const observer = new MutationObserver(() => patchGroupRows(root));
      observer.observe(root, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
